import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';

import { getFirstAvailableRoute, getRouteComponent } from './utilities/helpers';

export const Router = () => {
  const { routes: userRoutes } = useSelector((state: any) => state?.user?.data);

  const renderRoutes = ({ routes }: { routes: Route[] }) => {
    return routes
      .filter(({ is_locked }) => !is_locked)
      .map((route) => {
        const routeCatchChildren =
          route.routes?.length || ['instant-surveys'].includes(route.id) ? '/*' : '';

        return (
          <Route
            element={getRouteComponent(route)}
            key={route.id}
            path={`${route.path}${routeCatchChildren}`}
          />
        );
      });
  };

  return (
    <Routes>
      {renderRoutes({ routes: userRoutes })}
      <Route element={<Navigate replace to={getFirstAvailableRoute(userRoutes)} />} path="*" />
    </Routes>
  );
};

export default Router;
